import React from 'react';
import styles from './HotkeyInfo.module.scss';

const KEY_MAP: Record<string, string> = {
  Enter: '⏎',
  Tab: 'Tab',
};

interface HotkeyInfoProps {
  keys: Set<string>;
  action?: string | undefined;
}

const HotkeyInfo = ({ keys, action }: HotkeyInfoProps) => {
  return (
    <span className={styles.hotkeyInfo}>
      {Array.from(keys.values()).map((key, i) => {
        return (
          <span key={key}>
            {i > 0 ? ' or ' : null}
            <kbd>{KEY_MAP[key]}</kbd>
          </span>
        );
      })}
      {action ? <span>to {action}</span> : null}
    </span>
  );
};

export default HotkeyInfo;
